/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import Modal from 'react-responsive-modal';

import { toast } from 'react-toastify'; //토스트(toast)
//import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import Pay from '../containers/payment/Pay';
import AutoPay from '../containers/payment/AutoPay';

//import MemberShipBenefit from '../containers/ticket/MemberShipBenefit'
//import CashBenefit from '../containers/ticket/CashBenefit'
//import Banner from "../containers/ticket/Banner";
import Footer from '../components/Footer';

import ReactHoverObserver from 'react-hover-observer';

import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';
import moment from 'moment';

class Ticket extends Component {
  state = {
    payWindowOpen: false,
    payAlert: false,
    useCash: 0,
    payMethod: '',
    chkVal: '',
    memberShipOver1: false,
    memberShipOver2: false,

    memberCashOver1: false,
    memberCashOver2: false,
    memberCashOver3: false,

    m1Over: false,
    m2Over: false,
    m3Over: false,
    m4Over: false,
    m5Over: false,
    m6Over: false,
    c1Over: false,
    c2Over: false,
    c3Over: false,
  };
  componentDidMount = () => {
    window.addEventListener('message', this._payEnd);
  };
  componentWillUnmount = () => {
    window.removeEventListener('message', this._payEnd);
  };
  _payEnd = (e) => {
    const { setMemberShipPayEnd } = this.props;
    //const { freePassSerial } = this.state;
    //console.log(e)
    //if(e.data.type) {
    const callbackPart = e.data.callbackPart;
    const result = e.data.result;
    const orderCode = e.data.orderCode;

    //const me = this;
    //console.log(e.data)
    if (callbackPart === 'payment') {
      const gubun = e.data.gubun;
      if (gubun === 'auto') {
        if (result === 'success') {
          //toast.success('결제가 성공적으로 완료되었습니다.')
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
          setTimeout(() => {
            setMemberShipPayEnd(true, orderCode);
          }, 500);
        } else if (result === '-1') {
          toast.error('결제하려는 이용권이 존재하지 않습니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-2') {
          toast.error('잘못된 이용권 구매입니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-3') {
          toast.error('정기결제건이 존재합니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-4') {
          toast.error('해지 신청후 30일이후에 재신청이 가능합니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-4') {
          toast.error('사용중인 멤버십이 존재합니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else {
          toast.error('결제중 오류가 발생했습니다. 잠시후 다시 진행해 주세요.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
          //오류페이지로...
        }
      } else {
        if (result === 'success') {
          //toast.success('결제가 성공적으로 완료되었습니다.')
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
          setTimeout(() => {
            setMemberShipPayEnd(true, orderCode);
          }, 500);
        } else if (result === '-1') {
          toast.error('결제 정보가 누락되었습니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-2') {
          toast.error(
            '멤버십 결제는 사용기간이 남아 있는경우 4번이상 연속구매가 불가능합니다.'
          );
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-3') {
          toast.error(
            '현재 멤버십을 보유하고 있습니다. 멤버십이 종료되는 시점부터 청소년 이용권 구매가 가능합니다.(청소년결제 종료)'
          );
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-4') {
          toast.error(
            '현재 청소년 이용권를 보유하고 있습니다.\n\n청소년 이용권이 종료되는 시점부터 멤버십 구매가 가능합니다.'
          );
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-10') {
          toast.error('결제금액이 맞지 않습니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-11') {
          toast.error('포인트 아용액이 초과 되었습니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-20') {
          toast.error(
            '현재 정기결제 이용 고객으로  멤버십을 결제 할 수 없습니댜. 정기 결제 해지 후 결제가 가능합니다.'
          );
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else {
          toast.error('결제중 오류가 발생했습니다. 잠시후 다시 진행해 주세요.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
          //오류페이지로...
        }
      }
    }

    //} else {

    //}
  };

  _onPayMtoCApi = () => {
    const { loginId, apiUrl } = this.props;
    return axios
      .post(apiUrl + '/payChangeCheck', {
        params: {
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };

  _onPay = async (freePassSerial) => {
    const { loginId, setAgreeShow } = this.props;
    //history.push('/chat')
    //window.open('http://www.aniplustv.com/tv/ifr_chatting_intro.asp', '', '')
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요.');
    } else {
      //window.open('https://bill1.aniplustv.com/aniplus2020Api/pay/pay.asp?userid=' + loginId + '&freePassSerial=' + freePassSerial, 'pay', 'width=600, height=600')
      //window.open('https://bill1.aniplustv.com/pay/pay.asp?userid=' + loginId + '&freePassSerial=' + freePassSerial, 'pay ', 'width=600, height=600')

      // window.open('https://bill1.aniplustv.com/aniplus2020Api/pay/pay.asp?userid=badguyson&freePassSerial=53', 'pay', 'width=600, height=600')
      //window.open('', 'Order', 'width=620, height=840, top=150,left=100, menubars=no, statusbars=no, toolbars=no, titlebar=no, location=no, scrollbar=no');
      //document.frm.freePassSerial.value = freePassSerial;
      //document.frm.action = "https://bill1.aniplustv.com/purchase/order.asp";
      //document.frm.action = "https://bill1.aniplustv.com/aniplus2020Api/pay/pay.asp?userid=badguyson&freePassSerial=53"
      //document.frm.target = "Order";
      //document.frm.submit();
      const filter = 'win16|win32|win64|mac|macintel';
      console.log(navigator.platform);
      if (navigator.platform) {
        // if (0 > filter.indexOf(navigator.platform.toLowerCase())) {
        if (isMobile) {
          if (freePassSerial === 9) {
            //휴대폰 > 카드결제로 전환 가능 회원인지 조회
            const result = await this._onPayMtoCApi();
            const intReturn = result.data[0].intReturn;
            if (intReturn === 0) {
              //alert(0)
              setAgreeShow(true);
            } else {
              this.setState({
                freePassSerial: freePassSerial,
                payAlert: true,
              });
            }
          } else {
            this.setState({
              freePassSerial: freePassSerial,
              payAlert: true,
            });
          }

          // toast.warn('모바일의 경우 전용앱을 이용해 주시기 바랍니다.');
          // window.open(
          //   "https://bill1.aniplustv.com/aniplus2020api/PG/appPayment.asp?userid=" +
          //     loginId +
          //     "&freePassSerial=" +
          //     freePassSerial
          // );
          // //모바일
          //window.open('https://bill1.aniplustv.com/aniplus2020api/PG/order_auto_nativeApp.asp?userid=' + loginId + '&freePassSerial=' + freePassSerial)
        } else {
          //alert(freePassSerial)
          if (freePassSerial === 9) {
            //휴대폰 > 카드결제로 전환 가능 회원인지 조회
            const result = await this._onPayMtoCApi();
            const intReturn = result.data[0].intReturn;
            if (intReturn === 0) {
              //alert(0)
              setAgreeShow(true);
            } else {
              this.setState({
                freePassSerial: freePassSerial,
                payAlert: true,
              });
            }
          } else {
            this.setState({
              freePassSerial: freePassSerial,
              payAlert: true,
            });
          }

          //웹
          /*
                    this.setState({
                        payWindowOpen: true,
                        paymentUrl: 'https://bill1.aniplustv.com/aniplus2020Api/PG/index.asp?fs=' + freePassSerial + '&ui=' + loginId + '&m=SC0060'
                    })
                    */
        }
      }
    }
  };
  _onAuto = (freePassSerial, chuchon) => {
    const { payMethod } = this.state;
    const { loginId } = this.props;
    let paymentUrl = '';
    let payType = '';
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 결제가 가능합니다.');
      return false;
    } else {
      //console.log(authId)
      //window.open('https://www.aniplustv.com/purchase/order_auto.asp?freePassSerial=9', '', '')
      //window.open('https://bill1.aniplustv.com/aniplus2020Api/PG/auto.asp?userid=' + loginId + '&freePassSerial=' + freePassSerial + '&authId=' + authId, 'pay', 'width=600, height=600')

      //console.log(chuchon)
      let chuchonCode = '';
      if (chuchon === undefined || chuchon === null || chuchon === '') {
        chuchonCode = '';
      } else {
        chuchonCode = chuchon;
      }
      console.log(chuchonCode);
      const browser = this.isBrowserCheck();
      //console.log(browser)

      if (browser === -1) {
        toast.error(
          '지원되지 않는 브라우져 입니다. 크롬 및 IE Edge 브라우져 사용을 권장합니다.'
        );
        return;
      }

      if (payMethod === '' || payMethod === null || payMethod === undefined) {
        toast.warn('결제방식을 선택해 주세요');
        return false;
      } else {
        if (payMethod === 'SC0010') {
          //paymentUrl = 'https://bill1.aniplustv.com/aniplus2020Api/PG/auto_payment_c.asp'
          paymentUrl =
            'https://bill1.aniplustv.com/aniplus2020Api/PG/webPaymentAutoStep1.asp';
          payType = 'C';
        } else if (payMethod === 'SC0060') {
          paymentUrl =
            'https://bill1.aniplustv.com/aniplus2020Api/PG/auto_payment_m.asp';
          payType = 'M';
        } else {
          toast.error('매월 자동결제 방식을 선택해 주세요.');
          return false;
        }
        ////console.log(paymentUrl + '?userid=' + loginId + '&freePassSerial=' + freePassSerial + '&payType=' + payType)

        const filter = 'win16|win32|win64|mac|macintel';
        if (navigator.platform) {
          // if (0 > filter.indexOf(navigator.platform.toLowerCase())) {
          if (isMobile) {
            //모바일
            // toast.warn('모바일의 경우 전용앱에서 결제가 가능합니다.');
            this.setState({
              payWindowOpen: true,
              payAlert: false,
              paymentUrl:
                paymentUrl +
                '?userid=' +
                loginId +
                '&freePassSerial=' +
                freePassSerial +
                '&payType=' +
                payType +
                '&chuchon=' +
                chuchonCode,
              //paymentUrl: 'https://bill1.aniplustv.com/aniplus2020Api/PG/auto.asp?userid=' + loginId + '&freePassSerial=' + freePassSerial + '&authId=' + authId
            });

            // window.open(
            //   "https://bill1.aniplustv.com/aniplus2020api/PG/appPaymentAuto.asp?userid=" +
            //     loginId +
            //     "&freePassSerial=" +
            //     freePassSerial
            // );
            // window.open('https://bill1.aniplustv.com/aniplus2020api/PG/appPayment.asp?userid=' + loginId + '&freePassSerial=' + freePassSerial)
          } else {
            //console.log(paymentUrl + '?userid=' + loginId + '&freePassSerial=' + freePassSerial + '&payType=' + payType + '&chuchon=' + chuchon)

            this.setState({
              payWindowOpen: true,
              payAlert: false,
              paymentUrl:
                paymentUrl +
                '?userid=' +
                loginId +
                '&freePassSerial=' +
                freePassSerial +
                '&payType=' +
                payType +
                '&chuchon=' +
                chuchonCode,
              //paymentUrl: 'https://bill1.aniplustv.com/aniplus2020Api/PG/auto.asp?userid=' + loginId + '&freePassSerial=' + freePassSerial + '&authId=' + authId
            });
          }
        }
      }
    }
  };
  _changeCash = (useCash) => {
    this.setState({
      useCash: useCash,
    });
  };
  isBrowserCheck = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isChrome = userAgent.indexOf('chrome');
    const isEdge = userAgent.indexOf('edge');
    const isSafari = userAgent.indexOf('safari');
    //const isIE = userAgent.indexOf("trident");
    console.log(userAgent, isChrome, isEdge);
    //console.log(isIE)
    if (isChrome > -1) {
      if (isEdge > -1) {
        return 0;
      } else {
        return 0;
      }
    } else {
      if (isSafari > -1) {
        return 0;
      } else {
        return -1;
      }

      //alert("Chrome이 아닙니다");
    }
  };

  _onPayment = () => {
    const { freePassSerial, useCash, payMethod } = this.state;
    const { loginId } = this.props;

    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 결제가 가능합니다.');
      return false;
    } else {
      const browser = this.isBrowserCheck();
      console.log(browser);

      if (browser === -1) {
        toast.error(
          '지원되지 않는 브라우져 입니다. 크롬 및 IE Edge 브라우져 사용을 권장합니다.'
        );
        return;
      }

      if (payMethod === '' || payMethod === null || payMethod === undefined) {
        toast.warn('결제방식을 선택해 주세요');
        return false;
      } else {
        ////console.log('https://bill1.aniplustv.com/aniplus2020Api/PG/index.asp?fs=' + freePassSerial + '&ui=' + loginId + '&uc=' + useCash + '&m=' + payMethod)
        const filter = 'win16|win32|win64|mac|macintel';
        //if (navigator.platform) {
        // if (0 > filter.indexOf(navigator.platform.toLowerCase())) {
        console.log(isAndroid, isIOS);
        if (isMobile || isAndroid || isIOS) {
          window.open(
            'https://bill1.aniplustv.com/aniplus2020Api/PG/index.asp?fs=' +
              freePassSerial +
              '&ui=' +
              loginId +
              '&uc=' +
              useCash +
              '&m=' +
              payMethod
          );
          // window.open(
          //   "https://bill1.aniplustv.com/aniplus2020api/PG/order_nativeApp.asp?userid=" +
          //     loginId +
          //     "&freePassSerial=" +
          //     freePassSerial
          // );
        } else {
          this.setState({
            payWindowOpen: true,
            payAlert: false,
            paymentUrl:
              'https://bill1.aniplustv.com/aniplus2020Api/PG/index.asp?fs=' +
              freePassSerial +
              '&ui=' +
              loginId +
              '&uc=' +
              useCash +
              '&m=' +
              payMethod,
          });
        }
        //}
      }
    }
  };
  _onCashOnlyPayment = () => {
    const { freePassSerial, useCash } = this.state;
    const { loginId } = this.props;
    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 결제가 가능합니다.');
    } else {
      const payMethod = 'AN0001';
      this.setState({
        payWindowOpen: true,
        payAlert: false,
        paymentUrl:
          'https://bill1.aniplustv.com/aniplus2020Api/PG/cash.asp?fs=' +
          freePassSerial +
          '&ui=' +
          loginId +
          '&uc=' +
          useCash +
          '&m=' +
          payMethod,
      });
    }
  };
  onCloseAlert = () => {
    this.setState({
      payAlert: false,
    });
  };
  onCloseModal = () => {
    this.setState({
      payWindowOpen: false,
      paymentUrl: '',
    });
  };
  _selectPayMethod = (payMethod) => {
    this.setState({
      payMethod,
    });
  };
  _checkValue = (e) => {
    this.setState({
      chkVal: e.target.value,
    });
  };
  _select = (val) => {
    this.setState({
      chkVal: val,
    });
  };
  _payMemberShip = () => {
    const { loginId } = this.props;
    const { chkVal } = this.state;
    const endDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
    // console.log(endDate, chkVal);

    if (parseInt(chkVal) === 9 || parseInt(chkVal) === 10) {
      if (endDate >= '2024-09-29 29:59:59') {
        alert('신규 멤버십 서비스가 종료되었습니다.');
        return;
      }
    }

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요.');
      return false;
    }

    if (
      chkVal === 0 ||
      chkVal === null ||
      chkVal === undefined ||
      chkVal === ''
    ) {
      toast.warn('결제할 포인트를 선택해 주세요.');
    } else {
      if (chkVal === '9') {
        //this._onAuto(9)
        this._onPay(9);
      } else if (chkVal === '10') {
        this._onPay(10);
      } else if (
        chkVal === '56' ||
        chkVal === '55' ||
        chkVal === '54' ||
        chkVal === '53'
      ) {
        this._onPay(chkVal);
      }
    }
  };
  _onMosueOver1 = () => {
    //const { memberShipOver1, memberShipOver2 } = this.state;
    this.setState({
      memberShipOver1: true,
      memberShipOver2: false,
    });
  };
  _onMouseOut1 = () => {
    this.setState({
      memberShipOver1: false,
      memberShipOver2: false,
    });
  };
  _onMosueOver2 = () => {
    //const { memberShipOver1, memberShipOver2 } = this.state;
    this.setState({
      memberShipOver1: false,
      memberShipOver2: true,
    });
  };
  _onMouseOut2 = () => {
    this.setState({
      memberShipOver1: false,
      memberShipOver2: false,
    });
  };

  _onMouseOver3 = () => {
    //const { memberCashOver1, memberCashOver2, memberCashOver3 } = this.state;
    //console.log('aa')
    this.setState({
      memberCashOver1: true,
      memberCashOver2: false,
      memberCashOver3: false,
    });
  };
  _onMouseOut3 = () => {
    //const { memberCashOver1, memberCashOver2, memberCashOver3 } = this.state;

    this.setState({
      memberCashOver1: false,
      memberCashOver2: false,
      memberCashOver3: false,
    });
  };

  _onMouseOver4 = () => {
    //const { memberCashOver1, memberCashOver2, memberCashOver3 } = this.state;

    this.setState({
      memberCashOver1: false,
      memberCashOver2: true,
      memberCashOver3: false,
    });
  };
  _onMouseOut4 = () => {
    //const { memberCashOver1, memberCashOver2, memberCashOver3 } = this.state;

    this.setState({
      memberCashOver1: false,
      memberCashOver2: false,
      memberCashOver3: false,
    });
  };

  _onMouseOver5 = () => {
    //const { memberCashOver1, memberCashOver2, memberCashOver3 } = this.state;

    this.setState({
      memberCashOver1: false,
      memberCashOver2: false,
      memberCashOver3: true,
    });
  };
  _onMouseOut5 = () => {
    //const { memberCashOver1, memberCashOver2, memberCashOver3 } = this.state;

    this.setState({
      memberCashOver1: false,
      memberCashOver2: false,
      memberCashOver3: false,
    });
  };

  _mOver = (index) => {
    this.setState({
      m1Over: index === 1 ? true : false,
      m2Over: index === 2 ? true : false,
      m3Over: index === 3 ? true : false,
      m4Over: index === 4 ? true : false,
      m5Over: index === 5 ? true : false,
      m6Over: index === 6 ? true : false,
    });
  };
  _mOut = (index) => {
    this.setState({
      m1Over: index === 1 && false,
      m2Over: index === 2 && false,
      m3Over: index === 3 && false,
      m4Over: index === 4 && false,
      m5Over: index === 5 && false,
      m6Over: index === 6 && false,
    });
  };

  _cOver = (index) => {
    this.setState({
      c1Over: index === 1 ? true : false,
      c2Over: index === 2 ? true : false,
      c3Over: index === 3 ? true : false,
    });
  };
  _cOut = (index) => {
    this.setState({
      c1Over: index === 1 && false,
      c2Over: index === 2 && false,
      c3Over: index === 3 && false,
    });
  };
  render() {
    const {
      payWindowOpen,
      paymentUrl,
      payAlert,
      useCash,
      freePassSerial,
      payMethod,
      chkVal,
      memberShipOver1,
      memberShipOver2,
      memberCashOver1,
      memberCashOver2,
      memberCashOver3,
    } = this.state;

    const { imgUrl } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>멤버십, 포인트 충전 - 애니플러스</title>
          <meta name="title" content="멤버십, 포인트 충전 - 애니플러스" />
          <meta
            name="description"
            content="멤버십, 포인트 충전 - 스파이 패밀리, 진격의 거인, 주술회전"
          />
          <meta name="robots" content="index,follow" />
          <meta
            name="keywords"
            content="멤버십, 포인트, 충전, 애니플러스, 스파이 패밀리, 진격의 거인, 주술회전, 한일동시방영, 애니메이션, "
          />

          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="멤버십, 포인트 충전 - 애니플러스"
          />
          <meta
            property="og:description"
            content="멤버십, 포인트 충전 - 스파이 패밀리, 진격의 거인, 주술회전"
          />
          <meta property="og:url" content="https://www.aniplustv.com/live" />

          <meta name="twitter:card" content="summary" />
          <meta
            name="twitter:title"
            content="멤버십, 포인트 충전 - 애니플러스"
          />
          <meta
            name="twitter:description"
            content="멤버십, 포인트 충전 - 스파이 패밀리, 진격의 거인, 주술회전"
          />
          <meta
            name="twitter:domain"
            content="https://www.aniplustv.com/live"
          />

          <link rel="canonical" href="https://www.aniplustv.com/live" />
        </Helmet>
        <div className="cashcard_page_btn">
          {chkVal === '9' ? (
            <span>
              <em>
                {/* <img src="/img/cashcard/logo_img.png" /> */}
                멤버십
              </em>
              &nbsp;정기결제&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;월{' '}
              <strong>12,900</strong>원
            </span>
          ) : chkVal === '10' ? (
            <span>
              <em>
                {/* <img src="/img/cashcard/logo_img.png" /> */}
                멤버십
              </em>
              &nbsp;3개월&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
              <strong>45,000</strong>원
            </span>
          ) : chkVal === '56' ? (
            <span>
              <em>
                {/* <img src="/img/cashcard/logo_img.png" /> */}
                포인트충전
              </em>
              &nbsp;100,000포인트&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
              <strong>100,000</strong>원
            </span>
          ) : chkVal === '56' ? (
            <span>
              <em>
                {/* <img src="/img/cashcard/logo_img.png" /> */}
                포인트충전
              </em>
              &nbsp;100,000캐포인트&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
              <strong>100,000</strong>원
            </span>
          ) : chkVal === '55' ? (
            <span>
              <em>
                {/* <img src="/img/cashcard/logo_img.png" /> */}
                포인트충전
              </em>
              &nbsp;50,000포인트&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
              <strong>50,000</strong>원
            </span>
          ) : chkVal === '54' ? (
            <span>
              <em>
                {/* <img src="/img/cashcard/logo_img.png" /> */}
                포인트충전
              </em>
              &nbsp;30,000포인트&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
              <strong>30,000</strong>원
            </span>
          ) : chkVal === '53' ? (
            <span>
              <em>
                {/* <img src="/img/cashcard/logo_img.png" /> */}
                포인트충전
              </em>
              &nbsp;10,000포인트&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
              <strong>10,000</strong>원
            </span>
          ) : null}

          <a style={{ cursor: 'pointer' }} onClick={this._payMemberShip}>
            <div>결제하기</div>
          </a>
        </div>
        <div className="content" style={{ paddingTop: 0 }}>
          <div className="container_cashcard">
            <div className="content_cashcard">
              {/*멤버십 시작*/}
              {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
              '2024-09-29 23:59:59' ? null : (
                <div className="cashcard_group">
                  <div className="cashcard_group_img">
                    <div className="div_ul">
                      <ReactHoverObserver
                        hoverDelayInMs={200}
                        hoverOffDelayInMs={200}
                      >
                        {({ isHovering }) => (
                          <div className="div_li">
                            <div
                              className={
                                isHovering ? 'snip1283 hover' : 'snip1283'
                              }
                            >
                              <img
                                src={imgUrl + '/img/cashcard/img_member1.png'}
                              />
                              <figcaption>
                                <img
                                  src={
                                    imgUrl + '/img/cashcard/img_member1_o.png'
                                  }
                                />
                              </figcaption>
                            </div>
                          </div>
                        )}
                      </ReactHoverObserver>
                      <ReactHoverObserver
                        hoverDelayInMs={200}
                        hoverOffDelayInMs={200}
                      >
                        {({ isHovering }) => (
                          <div className="div_li">
                            <div
                              className={
                                isHovering ? 'snip1283 hover' : 'snip1283'
                              }
                            >
                              <img
                                src={imgUrl + '/img/cashcard/img_member2.png'}
                              />
                              <figcaption>
                                <img
                                  src={
                                    imgUrl + '/img/cashcard/img_member2_o.png'
                                  }
                                />
                              </figcaption>
                            </div>
                          </div>
                        )}
                      </ReactHoverObserver>
                      <ReactHoverObserver
                        hoverDelayInMs={200}
                        hoverOffDelayInMs={200}
                      >
                        {({ isHovering }) => (
                          <div className="div_li">
                            <div className="div_li">
                              <div
                                className={
                                  isHovering ? 'snip1283 hover' : 'snip1283'
                                }
                              >
                                <img
                                  src={imgUrl + '/img/cashcard/img_member3.png'}
                                />
                                <figcaption>
                                  <img
                                    src={
                                      imgUrl + '/img/cashcard/img_member3_o.png'
                                    }
                                  />
                                </figcaption>
                              </div>
                            </div>
                          </div>
                        )}
                      </ReactHoverObserver>
                    </div>
                    <p>↑ 마우스를 올려서 혜택안내를 확인해보세요.</p>
                  </div>
                  {/*
                                <div className="s_cashcard">
                                    <div className="s_cashcard_img"><div><img src="img/cashcard/img_member01.png"/></div></div>
                                    <div className="s_btn">
                                        <a href="#" className="pre_btn"><img src="img/cashcard/pre_btn.png"/></a>
                                        <a href="#" className="next_btn"><img src="img/cashcard/next_btn.png"/></a>
                                        <span className="on"></span><span></span><span></span><span></span><span></span><span></span>
                                    </div>
                                </div>
                                */}
                  <div className="member_ship_title">
                    <img src={imgUrl + '/img/cashcard/title1.png'} />
                  </div>
                  <div className="cashcard_group_text">
                    <h1>
                      <span className="mem_new">
                        {/*<img src="/img/cashcard/Layer_pop_up.png"/>*/}
                      </span>

                      <p className="member_new01">
                        모든 애니메이션은 애니플러스에서 시작된다.<em>!</em>
                      </p>
                      <p className="member_new02">
                        가장 빠르고 차별화된 서비스! 애니메이션 콘텐츠의 선두자!{' '}
                        <br />
                        최초 한일 동시방영 채널 애니플러스의 VOD 서비스를 체험해
                        보세요!
                      </p>

                      <span>
                        <img src={imgUrl + '/img/cashcard/chek_01.png'} />
                        원하시는 멤버십을 선택하세요<em>!</em>
                        <p style={{ paddingLeft: 35, color: '#ff5d24' }}>
                          정기결제에는 포인트 사용이 불가합니다.(단 3개월권에는
                          사용가능)
                        </p>
                      </span>
                    </h1>

                    <ul>
                      <li
                        onMouseEnter={this._onMosueOver1}
                        onMouseLeave={this._onMouseOut1}
                        onMouseUp={() => this._select('9')}
                      >
                        <div className="chek_all_group">
                          <input
                            name="선택"
                            id="checkbox_1"
                            type="checkbox"
                            value="9"
                            checked={chkVal === '9' ? true : false}
                            className="checkbox_img"
                            onChange={this._checkValue}
                          />
                          <label htmlFor="checkbox_1">선택하기</label>
                        </div>
                        {chkVal === '9' ? (
                          <img src={imgUrl + '/img/cashcard/member01_on.png'} />
                        ) : memberShipOver1 ? (
                          <img src={imgUrl + '/img/cashcard/member01_on.png'} />
                        ) : (
                          <img src={imgUrl + '/img/cashcard/member01.png'} />
                        )}
                      </li>

                      <li
                        onMouseEnter={this._onMosueOver2}
                        onMouseLeave={this._onMouseOut2}
                        onMouseUp={() => this._select('10')}
                      >
                        <div className="chek_all_group">
                          <input
                            name="선택"
                            id="checkbox_2"
                            type="checkbox"
                            value="10"
                            checked={chkVal === '10' ? true : false}
                            className="checkbox_img"
                            onChange={this._checkValue}
                          />
                          <label htmlFor="checkbox_2">선택하기</label>
                        </div>
                        {chkVal === '10' ? (
                          <img src={imgUrl + '/img/cashcard/member02_on.png'} />
                        ) : memberShipOver2 ? (
                          <img src={imgUrl + '/img/cashcard/member02_on.png'} />
                        ) : (
                          <img src={imgUrl + '/img/cashcard/member02.png'} />
                        )}
                      </li>
                    </ul>
                  </div>
                  <div className="member_new03">
                    <dl>
                      <dt>
                        <span>멤버십</span>이용안내
                      </dt>
                      <dd>
                        <p>
                          각 에피소드의 VOD는 애니플러스 TV 채널 방영 직후에
                          업데이트 됩니다.
                        </p>
                        <p>
                          원저작권사의 요청에 따라, 일부 작품은 다운로드
                          서비스가 제공되지 않거나 애니플러스 포인트를 통해서만
                          감상 가능합니다.
                        </p>
                        <p>
                          정기 결제는 매월 지정된 결제 일자 및 수단을 통해 자동
                          결체/청구 됩니다.
                        </p>
                        <p>
                          배송비 무료는 멤버십 회원 기간 중 주문/결제한 건에
                          대해서만 적용됩니다.
                        </p>
                        <p>
                          일부 상영회는 멤버십 회원 우선 권한이 주어지지 않을 수
                          있습니다.
                          <br />
                          <br />
                        </p>
                      </dd>
                    </dl>
                    <dl>
                      <dt>
                        <span>멤버십</span>환불안내
                      </dt>
                      <dd>
                        <p>결제일 기준 만 7일이내 환불 신청이 가능합니다.</p>
                        <p>
                          단 아래와 같은 경우 환불이 불가합니다
                          <br />
                          - 해당 멤버십 기간 중 멤버십 서비스 이용 내역이 1건
                          이상 있을 경우.
                          <br />
                          - 멤멤버십 결제로 지급된 혜택/서비스를 이용했을 경우
                          <br />- 결제일 기준 만 7일을 경과하여 환불을 신청했을
                          경우.
                          <br />
                        </p>
                      </dd>
                    </dl>
                  </div>
                  {/*<Banner />*/}
                </div>
              )}

              {/*멤버십 끝*/}
              <div className="cashcard_group2">
                {/*<CashBenefit/>*/}

                <div className="cashcard_group_img">
                  <div className="div_ul">
                    <ReactHoverObserver
                      hoverDelayInMs={200}
                      hoverOffDelayInMs={200}
                    >
                      {({ isHovering }) => (
                        <div className="div_li">
                          <div
                            className={
                              isHovering ? 'snip1283 hover' : 'snip1283'
                            }
                          >
                            <img
                              src={imgUrl + '/img/cashcard/img_cashcard1.png'}
                            />
                            <figcaption>
                              <img
                                src={
                                  imgUrl + '/img/cashcard/img_cashcard1_o.png'
                                }
                              />
                            </figcaption>
                          </div>
                        </div>
                      )}
                    </ReactHoverObserver>

                    <ReactHoverObserver
                      hoverDelayInMs={200}
                      hoverOffDelayInMs={200}
                    >
                      {({ isHovering }) => (
                        <div className="div_li">
                          <div
                            className={
                              isHovering ? 'snip1283 hover' : 'snip1283'
                            }
                          >
                            <img
                              src={imgUrl + '/img/cashcard/img_cashcard2.png'}
                            />
                            <figcaption>
                              <img
                                src={
                                  imgUrl + '/img/cashcard/img_cashcard2_o.png'
                                }
                              />
                            </figcaption>
                          </div>
                        </div>
                      )}
                    </ReactHoverObserver>
                    {/* <ReactHoverObserver
                      hoverDelayInMs={200}
                      hoverOffDelayInMs={200}
                    >
                      {({ isHovering }) => (
                        <div className="div_li">
                          <div
                            className={
                              isHovering ? "snip1283 hover" : "snip1283"
                            }
                          >
                            <img src="/img/cashcard/img_cashcard3.png" />
                            <figcaption>
                              <img src="/img/cashcard/img_cashcard3_o.png" />
                            </figcaption>
                          </div>
                        </div>
                      )}
                    </ReactHoverObserver> */}
                  </div>
                  <p>↑ 마우스를 올려서 혜택안내를 확인해보세요.</p>
                </div>
                <div className="cashcard_group_text">
                  <h1>
                    <img src={imgUrl + '/img/cashcard/title2.png'} />
                    <span>
                      <img src={imgUrl + '/img/cashcard/chek_01.png'} />
                      원하시는 포인트충전을 선택하세요!{' '}
                      {/*<strong>(충전시 최대 10% 추가지급)</strong>*/}
                    </span>
                  </h1>
                  <ul>
                    <li
                      onMouseEnter={this._onMouseOver3}
                      onMouseLeave={this._onMouseOut3}
                      onMouseUp={() => this._select('56')}
                    >
                      {/* <div className="member_new05">
                        <img src="/img/cashcard/ico_per.png" />
                      </div> */}
                      <div className="chek_all_group">
                        <input
                          name="선택"
                          id="checkbox_3"
                          type="checkbox"
                          value="56"
                          checked={chkVal === '56' ? true : false}
                          className="checkbox_img"
                          onChange={this._checkValue}
                        />
                        <label htmlFor="checkbox_3">선택하기</label>
                      </div>
                      {chkVal === '56' ? (
                        <img src={imgUrl + '/img/cashcard/img011_on.png'} />
                      ) : memberCashOver1 ? (
                        <img src={imgUrl + '/img/cashcard/img011_on.png'} />
                      ) : (
                        <img src={imgUrl + '/img/cashcard/img011.png'} />
                      )}
                    </li>
                    <li
                      onMouseEnter={this._onMouseOver4}
                      onMouseLeave={this._onMouseOut4}
                      onMouseUp={() => this._select('54')}
                    >
                      <div className="chek_all_group">
                        <input
                          name="선택"
                          id="checkbox_4"
                          type="checkbox"
                          value="54"
                          checked={chkVal === '54' ? true : false}
                          className="checkbox_img"
                          onChange={this._checkValue}
                        />
                        <label htmlFor="checkbox_4">선택하기</label>
                      </div>
                      {chkVal === '54' ? (
                        <img src={imgUrl + '/img/cashcard/img021_on.png'} />
                      ) : memberCashOver2 ? (
                        <img src={imgUrl + '/img/cashcard/img021_on.png'} />
                      ) : (
                        <img src={imgUrl + '/img/cashcard/img021.png'} />
                      )}
                    </li>
                    <li
                      onMouseEnter={this._onMouseOver5}
                      onMouseLeave={this._onMouseOut5}
                      onMouseUp={() => this._select('53')}
                    >
                      <div className="chek_all_group">
                        <input
                          name="선택"
                          id="checkbox_5"
                          type="checkbox"
                          value="53"
                          checked={chkVal === '53' ? true : false}
                          className="checkbox_img"
                          onChange={this._checkValue}
                        />
                        <label htmlFor="checkbox_5">선택하기</label>
                      </div>
                      {chkVal === '53' ? (
                        <img src={imgUrl + '/img/cashcard/img031_on.png'} />
                      ) : memberCashOver3 ? (
                        <img src={imgUrl + '/img/cashcard/img031_on.png'} />
                      ) : (
                        <img src={imgUrl + '/img/cashcard/img031.png'} />
                      )}
                    </li>
                  </ul>

                  <dl>
                    <dt>
                      <span>포인트</span>이용안내
                    </dt>
                    <dd>
                      <p>
                        포인트는 애니플러스가 제공하는 온/오프라인의 다양한
                        서비스에서 현금처럼 사용 가능합니다.
                        <br />단 정기결제 멤버십에는 사용할 수 없습니다.
                        (3개월권에는 사용 가능)
                      </p>
                      <p>
                        포인트는 애니플러스가 제공하는 수단에 따라
                        사이트/모바일에서 충전 가능합니다.
                      </p>
                      <p>
                        유상으로 충전한 포인트의 유효 기간은 지급 시점으로부터
                        1년입니다.
                      </p>
                      <p>
                        포인트는 다른 결제 수단과 병행하여 사용 가능합니다. 다만
                        일부 행사/ 상품/ 작품에 따라 사용이 제한될 수 있습니다.
                      </p>
                      <p>
                        VOD / 다운로드는 최초 결제일로부터 48시간 이내에만
                        재관람 및 다운로드 가능합니다. (다운로드 최대 3회)
                      </p>
                      <p>
                        기존 보유하고 있던 캐시는 모두 포인트로 전환되며,
                        유효기간 또한 기존 캐시와 동일합니다.
                        <br />
                      </p>
                    </dd>
                  </dl>
                  <br />
                  <dl>
                    <dt>
                      <span>포인트</span>환불안내
                    </dt>
                    <dd>
                      <p>
                        유상으로 결제하고 충전된 포인트는 환불 및 결제 취소가
                        가능합니다.(결제된 수단과 동일한 수단으로 환불됩니다.)
                      </p>
                      <p>
                        아래와 같은 경우 환불 및 결제 취소가 가능합니다.
                        <br />
                        - 포인트 충전 이후 유상/무료로 지급된 포인트를 사용한
                        내역이 없는 경우 &gt; 결제 취소
                        <br />- 유상 충전 금액 총합의 60% 이상이 사용된 경우
                        &gt; 환불 수수료 10%를 추가 제외한 후 환불 진행
                      </p>
                      <p>
                        무상으로 제공된 포인트(캐시)는 환불 대상이 되지
                        않습니다.
                      </p>
                    </dd>
                  </dl>
                </div>
                {/*<Banner />*/}
                {/*
                                <div className="s_cashcard">
                                    <div className="s_cashcard_img"><div><img src="img/cashcard/test.png"/></div></div>
                                    <div className="s_btn">
                                        <span className="on"></span><span></span><span></span><span></span><span></span><span></span>
                                    </div>
                                </div>
                                */}
              </div>
            </div>
          </div>
        </div>
        {/*
                <div style={{paddingTop: 300, color: '#ffffff'}}>
                    <p>멤버십</p>
                    <p onClick={()=>this._onAuto(9)}>정기 결제</p>
                    <p onClick={()=>this._onPay(10)}>3개월 멤버십 결제</p>
                    <a style={{cursor: 'pointer'}} onClick={()=>this._onPay(53)}>11,000 포인트 충전</a>
                    <p onClick={()=>this._onPay(54)}>33,000 포인트 충전</p>
                    <p onClick={()=>this._onPay(55)}>55,000 포인트 충전</p>
                    <p onClick={()=>this._onPay(56)}>110,000 포인트 충전</p>

                    <form name="frm" method="post">
                    <input type="hidden" name="freePassSerial" value="53"/>
                    </form>
                </div>
                */}

        <Footer />

        <Modal
          open={payAlert}
          showCloseIcon={false}
          onClose={this.onCloseAlert}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          center
        >
          {freePassSerial === 9 ? (
            <AutoPay
              changeCash={this._changeCash}
              selectPayMethod={this._selectPayMethod}
              payMethod={payMethod}
              useCash={useCash}
              freePassSerial={freePassSerial}
              onPayment={this._onAuto}
              onCashOnlyPayment={this._onCashOnlyPayment}
              onCloseAlert={this.onCloseAlert}
            />
          ) : (
            <Pay
              changeCash={this._changeCash}
              selectPayMethod={this._selectPayMethod}
              payMethod={payMethod}
              useCash={useCash}
              freePassSerial={freePassSerial}
              onPayment={this._onPayment}
              onCashOnlyPayment={this._onCashOnlyPayment}
              onCloseAlert={this.onCloseAlert}
            />
          )}
        </Modal>

        <Modal
          open={payWindowOpen}
          onClose={this.onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={true}
          center
        >
          <div style={{ width: 750, height: 750 }}>
            <div
              onClick={this.onCloseModal}
              style={{ cursor: 'pointer', zIndex: 10000000 }}
            >
              취소
            </div>
            <iframe
              src={paymentUrl ? paymentUrl : ''}
              frameBorder="0"
              scrolling="yes"
              style={{ border: 'none', width: 750, height: 700, marginTop: 50 }}
            ></iframe>
          </div>
        </Modal>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Ticket));
